import styled, { keyframes } from 'styled-components';
import UIIcon from 'UIComponents/icon/UIIcon';
const zoom = keyframes(["0%{transform:scale(0.8);opacity:1;}70%{transform:scale(1.4);opacity:1;}100%{transform:scale(1);opacity:1;}"]);
const IconWithClickAnimation = styled(UIIcon).withConfig({
  displayName: "IconWithClickAnimation",
  componentId: "sc-13jy293-0"
})(["&:active{animation:", " 300ms cubic-bezier(0.42,0,0.58,1);animation-fill-mode:forwards;}"], zoom);
export default IconWithClickAnimation;